import React, { useEffect } from "react";

export default function Confirm({
  title,
  message,
  confirmLabel = "OK",
  secondaryLabel,
  danger,
  onConfirm,
  onSecondary,
  onCancel,
}) {
  useEffect(() => {
    function handleKey(e) {
      if (e.key === "Escape") onCancel();
    }
    window.addEventListener("keydown", handleKey);
    return () => window.removeEventListener("keydown", handleKey);
  }, [onCancel]);

  const dangerStyle = danger
    ? {
        background: "rgba(239,68,68,0.15)",
        borderColor: "rgba(239,68,68,0.5)",
        color: "#fca5a5",
      }
    : undefined;

  return (
    <div
      className="modal-backdrop"
      onMouseDown={(e) => {
        if (e.target === e.currentTarget) onCancel();
      }}
    >
      <div className="confirm" data-testid="confirm-dialog">
        <h3>{title}</h3>
        <p>{message}</p>
        <div className="confirm-actions">
          <button className="btn" onClick={onCancel} data-testid="confirm-cancel">
            Abbrechen
          </button>
          {secondaryLabel && (
            <button className="btn" onClick={onSecondary} data-testid="confirm-secondary">
              {secondaryLabel}
            </button>
          )}
          <button
            className={`btn ${danger ? "btn-danger" : "btn-gold"}`}
            onClick={onConfirm}
            data-testid="confirm-ok"
            style={dangerStyle}
          >
            {confirmLabel}
          </button>
        </div>
      </div>
    </div>
  );
}
